import { render } from "./honoreeFilterItem.vue?vue&type=template&id=380414a8"
import script from "./honoreeFilterItem.vue?vue&type=script&lang=js"
export * from "./honoreeFilterItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__